export function isOneOf(a,b,c,d,e){return value=>a(value)||b(value)||!!c&&c(value)||!!d&&d(value)||!!e&&e(value)}export default isOneOf;